import { registerLocaleData } from '@angular/common';
import localDE from '@angular/common/locales/de';
import { Component, effect, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { NgxSonnerToaster } from 'ngx-sonner';
import { FeatureFlagService, HeaderService, LocaleService } from 'shared/domain';
import { LANG } from 'shared/util-common';

import { createMaintenanceToolbar } from './app.component.util';
import { HeaderComponent } from './header/header.component';

registerLocaleData(localDE);

@Component({
  selector: 'tt-app-root',
  templateUrl: './app.component.html',
  standalone: true,
  providers: [],
  styleUrls: ['./app.component.scss'],
  imports: [
    MatToolbarModule,
    MatIconModule,
    RouterOutlet,
    HeaderComponent,
    MatIconModule,
    FormsModule,
    NgxSonnerToaster,
  ],
})
export class AppComponent implements OnInit {
  private translateService = inject(TranslocoService);
  private localeService = inject(LocaleService);
  private adapter = inject(DateAdapter<MomentDateAdapter>);
  private featureFlagService = inject(FeatureFlagService);
  private router = inject(Router);
  private headerService = inject(HeaderService);

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.headerService.showHeader();
      }
    });

    effect(() => {
      const maintenance = this.featureFlagService.maintenance();

      if (!maintenance || !maintenance.isScheduled) {
        return;
      }

      const maintenanceToolbar = createMaintenanceToolbar(maintenance.message, this.translateService.getActiveLang());

      document.body.prepend(maintenanceToolbar);
      document.body.style.display = 'flex';
      document.body.style.flexDirection = 'column';
    });
  }

  public ngOnInit(): void {
    this.initLanguage();

    this.localeService.locale$.subscribe((lang) => {
      if (lang) {
        this.setLanguage(lang);
      }
    });
  }

  private initLanguage(): void {
    const defaultLanguage = 'en';

    this.translateService.setAvailableLangs([defaultLanguage, 'de']);
    this.translateService.setDefaultLang(defaultLanguage);

    const userLang: string = navigator.language || (navigator['userLanguage'] as string);
    let majorLang = userLang.substring(0, 2);

    const lang = localStorage.getItem(LANG);
    const availableLangs = this.translateService.getAvailableLangs() as string[];
    if (lang && availableLangs.includes(lang)) {
      majorLang = lang;
    }

    this.setLanguage(majorLang);
  }

  private setLanguage(lang: string): void {
    this.translateService.setActiveLang(lang);
    this.adapter.setLocale(lang);
  }
}
